export const API = "https://binary-brains.herokuapp.com";
// export const API = "http://localhost:8050";
